import React, { Component } from 'react'
import Modal from 'react-modal'

import '../../../assets/css/0010_sections/0530_section-espace_exclu.css'

import { urlToHost } from "../../../utilities/FrontFunctions/AoxFrontFunctions"

const customStyles = {
	overlay : {
		zIndex			: '99999',
		backgroundColor	: 'rgba(0,0,0,0.6)'
	},
	content : {
		position	: 'fixed',
		top			: '50%',
		left		: '50%',
		right		: 'auto',
		bottom		: 'auto',
		transform	: 'translate(-50%, -50%)',
		outline		: '0'
	}
}

Modal.setAppElement('#root')

class ModalEspaceExclu extends Component {
	constructor() {
		super()
		this.state = {
			modalIsOpen: false,
		}
		this.openModal = this.openModal.bind(this)
		this.closeModal = this.closeModal.bind(this)
		this.bouton1 = this.bouton1.bind(this)
		this.bouton2 = this.bouton2.bind(this)
	}
	componentDidMount() {
		this.props.onRef(this)
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}
	openModal() {
		this.setState({modalIsOpen: true})
	}
	closeModal() {
		this.setState({modalIsOpen: false})
	}
	bouton1() {
        localStorage.setItem('dontShowAgainModalEspaceExclu', 'true');
        window.location.href = urlToHost(this.props.scData.lien.jss.value.href);
	}
	bouton2() {
		this.setState({modalIsOpen: false});
	}

	render() {
        const { scData } = this.props;

		return (
			<>
				<Modal
					isOpen={this.state.modalIsOpen}
					onRequestClose={this.closeModal}
					style={customStyles}
					className="obj_popin var_espace_exclu"
					closeTimeoutMS={300}
					contentLabel="Modal"
				>
					<button className="bt_close" onClick={this.closeModal}></button>
					<div className="ctn_popin">
						<div className="section_espace_exclu">
							<div className="ctn_bottom">
								<div className="ctn_buttons">
									<button className="obj_button" onClick={this.bouton1}>{scData.texteBouton1.jss.value}</button>
									<button className="obj_button var_txt" onClick={this.bouton2}>{scData.texteBouton2.jss.value}</button>
								</div>
							</div>
						</div>

						<div className='ctn_background'>
							<div className='obj_image image_cover'>
								<picture className='ctn_image fade-in'>
									<source srcSet={scData.imageMobile.jss.value.src} media="(max-width:767px)"/>
									<img src={scData.image.jss.value.src} alt=""/>
								</picture>
							</div>
						</div>
					</div>
				</Modal>
			</>
		)
	}
}

export default ModalEspaceExclu